import * as React from 'react';
import WalmartFilterBranchRenderer from 'flow-doctor-lib/components/filters/WalmartFilterBranchRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentValidationDebugFilterEvaluation = ({
  listId,
  evaluationResult,
  flowRevision,
  children
}) => {
  const maybeAssociatedList = flowRevision.flow.associatedLists.find(list => list.listId === listId);
  return /*#__PURE__*/_jsxs("div", {
    children: [children, maybeAssociatedList && evaluationResult && /*#__PURE__*/_jsx(WalmartFilterBranchRenderer, {
      objectTypeId: flowRevision.flow.objectTypeId,
      filterBranch: maybeAssociatedList.filterBranch,
      debugOptions: {
        filterBranch: evaluationResult,
        displayMode: 'ALL'
      },
      filterWidthType: "DEFAULT"
    })]
  });
};
export default EnrollmentValidationDebugFilterEvaluation;